import { Button, Dialog, DialogActions, DialogContent, MenuItem, TextField } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../components/DialogTitleWithCloseButton";
import { getAgentFullName } from "../../../../../shared/utils";
import EditableTextbox from "../../../components/EditableTextbox";
import { PAYMENT_TYPE } from "../../../../../shared/constants";
import AttachmentInput from "../../../components/AttachmentInput";
import SearchItem from "../../../components/SearchItem";
import request from "../../../request";
import { errorToast } from "../../../toast";
import { hideLoading, showLoading } from "../../../loading";
import swal from "sweetalert";


export default class Payout extends Component {

   state = {
      amount: 0,
      type: '',
      proofOfPayment: null,
      bankAccount: null,
   }

   getDefaultAmount = () => {
      return this.props.amount - this.props.paid;
   }

   submit = async () => {

      // validate form
      const txtAmount = document.getElementById('txt-amount');
      const txtPaymentType = document.getElementById('txt-payment-type');
      const txtBankAccount = document.getElementById('txt-bank-account');
      
      const { amount, type, proofOfPayment, bankAccount } = this.state;

      if (!amount) {
         errorToast('Please enter amount');
         return txtAmount.focus();
      }

      if (!type) {
         errorToast('Please select payment type');
         return txtPaymentType.focus();
      }

      if (!bankAccount) {
         errorToast('Please select bank account');
         return txtBankAccount.focus();
      }

      // submit
      try {

         showLoading();

         const attachments = [];
         if (proofOfPayment) {
            attachments.push({
               name: proofOfPayment.name,
               base64: proofOfPayment.base64,
               ext: proofOfPayment.ext,
            });
         }

         const data = {
            amount: parseFloat(amount),
            type,
            attachments,
            bank_account: bankAccount.id,
         };

         const res = await request.post(`/api/finance/agent-earnings/${this.props._id}/payments`, data);
         this.props.onClose(res.data);
      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }

   }

   componentDidMount() {
      this.setState({ amount: this.getDefaultAmount() });
   }

   render() {

      return <Dialog open fullWidth maxWidth="xs">
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Payout for {getAgentFullName(this.props.agent)}
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className="flex flex-col gap-4">
               <EditableTextbox
                  id="txt-amount"
                  label="Amount"
                  defaultValue={this.getDefaultAmount()}
                  value={this.state.amount}
                  onChange={amount => this.setState({ amount })}
                  type="number"
                  size="small"
               />
               
               <TextField
                  id="txt-payment-type"
                  label="Payment Type"
                  value={this.state.type}
                  onChange={e => this.setState({ type: e.target.value })}
                  size="small"
                  fullWidth
                  select
               >
                  {
                     Object
                        .values(PAYMENT_TYPE)
                        .map(value => (
                           <MenuItem key={value} value={value}>
                              {value.replace(/_/g, ' ').toUpperCase()}
                           </MenuItem>
                        ))
                  }
               </TextField>

               <AttachmentInput
                  id="txt-proof-of-payment"
                  label="Proof of Payment"
                  name={this.state.proofOfPayment?.name}
                  onChange={proofOfPayment => this.setState({ proofOfPayment })}
                  size="small"
               />
               
               <SearchItem
                  id="txt-bank-account"
                  label="Bank Account"
                  value={this.state.bankAccount}
                  onChange={bankAccount => this.setState({ bankAccount })}
                  size="small"
                  fetchData={
                     async () => {
                        const res = await request.get('/api/general/quickbooks/bank-accounts');
                        return res.data.accounts;
                     }
                  }
                  transformOption={opt => ({ ...opt, label: opt.name })}
               />
            </div>
         </DialogContent>
         <DialogActions>
            <Button onClick={this.submit} variant="contained">
               Submit
            </Button>
         </DialogActions>
      </Dialog>
   }
}